module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07_ack#ch00_fm07_ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm08_intro#ch00_fm08_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm08_intro#ch00_fm08_introa"
    }
  }, [_c('em', [_vm._v("Craig R. Prentiss")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 “A Servant of Servants Shall He Be”: The Construction of Race in American Religious Mythologies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01a"
    }
  }, [_c('em', [_vm._v("Paul Harvey")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Myth and African American Self-Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Eddie S. Glaude, Jr.")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Almost White: The Ambivalent Promise of Christian Missions among the Cherokees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Joel Martin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Indigenous Identity and Story:"), _c('br'), _vm._v("The Telling of Our Part in the Sacred Homeland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Nimachia Hernandez")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Jew and Judaist, Ethnic and Religious:"), _c('br'), _vm._v("How They Mix in America")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jacob Neusner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Blackness in the Nation of Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Aminah Beverly McCloud")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Theologizing Race:"), _c('br'), _vm._v("The Construction of “Christian Identity”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Douglas E. Cowan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 “Loathsome unto Thy People”:"), _c('br'), _vm._v("The Latter-day Saints and Racial Categorization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Craig R. Prentiss")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Our Lady of Guadalupe: The Heart of Mexican Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Roberto S. Goizueta")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Myths, Shinto, and "), _c('em', [_vm._v("Matsuri")]), _c('br'), _vm._v("in the Shaping of Japanese Cultural Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("John K. Nelson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Islam, Arabs, and Ethnicity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Azzam Tamimi")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Cosmic Men and Fluid Exchanges: Myths of "), _c('em', [_vm._v("Arya, Varna")]), _vm._v(","), _c('br'), _vm._v("and "), _c('em', [_vm._v("Jāti")]), _vm._v(" in the Hindu Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Laurie L. Patton")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Religious Myth and the Construction of Shona Identity 197")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chirevo V. Kwenda")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Sacral Ruins in Bosnia-Herzegovina:"), _c('br'), _vm._v("Mapping Ethnoreligious Nationalism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Michael A. Sells")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16_index#ch16_index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e7c9482","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_toc.vue
// module id = 75
// module chunks = 0